module.exports = __webpack_public_path__ + "img/suit-09.c3c8c102.png";